module.exports = __webpack_public_path__ + "media/anim3.6a5ebc9f.webm";